import React from 'react';
import { FaTrash } from '@react-icons/all-files/fa/FaTrash';

// ── Types ────────────────────────────────────────────────────────────────────

interface EdgePropsPanel {
    currentEdge: any;
    removeEdge: (edge: any) => void;
    editarTipoNodo?: boolean;
    editarActividad?: ((edge: any) => void) | boolean;
}

// ── Component ────────────────────────────────────────────────────────────────

export default function WorkflowEdgeProperties({
    currentEdge,
    removeEdge,
}: EdgePropsPanel) {
    return (
        <div style={s.panel}>

            {/* Header */}
            <div style={s.header}>
                <span style={s.title}>Propiedades de la conexión</span>
                <span style={s.badge}>Conexión</span>
            </div>

            <div style={s.divider} />

            {/* Fields */}
            <div style={s.fields}>

                <div style={s.fieldGroup}>
                    <span style={s.label}>ID</span>
                    <div style={s.readOnly}>{currentEdge?.id ?? '—'}</div>
                </div>

                <div style={s.fieldGroup}>
                    <span style={s.label}>Origen</span>
                    <div style={s.readOnly}>{currentEdge?.source ?? '—'}</div>
                </div>

                <div style={s.fieldGroup}>
                    <span style={s.label}>Destino</span>
                    <div style={s.readOnly}>{currentEdge?.target ?? '—'}</div>
                </div>

            </div>

            <div style={s.divider} />

            {/* Actions */}
            {/* <button style={s.btnDanger} onClick={() => removeEdge(currentEdge)}>
                <FaTrash style={{ marginRight: 6 }} />
                Eliminar conexión
            </button> */}

        </div>
    );
}

// ── Styles ────────────────────────────────────────────────────────────────────

const s: Record<string, React.CSSProperties> = {
    panel: {
        display: 'flex', flexDirection: 'column', gap: 12,
        padding: '16px 0',
    },
    header: {
        display: 'flex', alignItems: 'center',
        justifyContent: 'space-between', gap: 8,
    },
    title: { fontSize: 13, fontWeight: 700, color: '#0f172a' },
    badge: {
        padding: '2px 10px', borderRadius: 20, fontSize: 11,
        fontWeight: 700, background: '#fef9c3', color: '#854d0e',
        letterSpacing: '0.04em',
    },
    divider: { borderTop: '1px solid #f1f5f9', margin: '4px 0' },
    fields: { display: 'flex', flexDirection: 'column', gap: 12 },
    fieldGroup: { display: 'flex', flexDirection: 'column', gap: 4 },
    label: {
        fontSize: 11, fontWeight: 600, color: '#64748b',
        textTransform: 'uppercase', letterSpacing: '0.05em',
    } as React.CSSProperties,
    readOnly: {
        fontSize: 13, color: '#1e293b',
        padding: '6px 0', borderBottom: '1px solid #f1f5f9',
        wordBreak: 'break-all',
    } as React.CSSProperties,
    btnDanger: {
        display: 'flex', alignItems: 'center',
        padding: '7px 12px', background: '#fef2f2', color: '#b91c1c',
        border: '1px solid #fecaca', borderRadius: 7,
        fontSize: 12, fontWeight: 600, cursor: 'pointer', width: '100%',
    },
};
